import { z } from 'zod';

export const safetyZoneSchema = z.object({
  id: z.string().uuid(),
  name: z.string().trim().min(1).max(100),
  severity: z.enum(['WARNING', 'DANGER']),
  shape: z.literal('CIRCLE'),
  center: z.object({ latitude: z.number().finite().min(-90).max(90), longitude: z.number().finite().min(-180).max(180) }),
  radius_m: z.number().finite().positive(),
  enabled: z.boolean(),
  group_id: z.string().uuid().nullable(),
});

export type WorkerSafetyZone = z.infer<typeof safetyZoneSchema>;

export const safetyZoneCollectionSchema = z.object({ zones: z.array(safetyZoneSchema) }).superRefine(({ zones }, context) => {
  if (new Set(zones.map(zone => zone.id)).size !== zones.length) context.addIssue({ code: 'custom', message: '구역 ID가 중복되었습니다.' });
  const groups = new Map<string, WorkerSafetyZone[]>();
  for (const zone of zones) {
    if (zone.group_id) groups.set(zone.group_id, [...(groups.get(zone.group_id) ?? []), zone]);
  }
  for (const linked of groups.values()) {
    const warning = linked.find(zone => zone.severity === 'WARNING');
    const danger = linked.find(zone => zone.severity === 'DANGER');
    if (
      linked.length !== 2 ||
      !warning ||
      !danger ||
      danger.radius_m >= warning.radius_m ||
      warning.center.latitude !== danger.center.latitude ||
      warning.center.longitude !== danger.center.longitude
    )
      context.addIssue({ code: 'custom', message: '연결 구역은 같은 중심의 작은 위험 원과 큰 경고 원이어야 합니다.' });
  }
});

export const safetyZoneSettingsSchema = safetyZoneCollectionSchema.and(
  z.object({
    field_uid: z.string().uuid(),
    schema_version: z.literal(1),
    revision: z.number().int().nonnegative().safe(),
  })
);

export type SafetyZoneSettings = z.infer<typeof safetyZoneSettingsSchema>;
